import { db, auth } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, orderBy, serverTimestamp, startAfter, limit } from 'firebase/firestore';

// Actions
import { setAlert } from './alertActions';
import { sendEmail } from './emailActions';

import {  
    ISSUES_PROCESSING,
    ISSUES_PROCESSING_DONE
} from './types';

// Reference to the "notifications" collection in Firestore
const issuesCollectionRef = collection(db, "issues");

// Create New Issue
export const createIssue = ( formData ) => async dispatch => {

    dispatch(setIssuesProcessing());

    const {
        email,
        issue,
    } = formData;

    try {
        // --- Prepare the fields for the new issue document

        const docFields = {};
        
        docFields.email = email;
        docFields.issue = issue;
        docFields.date = Date.now();
        docFields.createdAt = serverTimestamp();

        // Add the new notification document to the notifications collection
        await addDoc(issuesCollectionRef, docFields);

        dispatch(setAlert("Sent Successfully!", 'success'));

        // --- Send Email ----

        dispatch(sendEmail(
            {       
                type: 'issue_reported',
                email,
                message: issue
            }
        ));

        // --- END: Send Email ----

    } catch (err) {
        console.log('ERROR CREATING ISSUE!!!');
        console.log(err);

        // Handle the error if creating the issue fails
        dispatch(setAlert("Something went wrong.", 'danger'));
    } finally {
        dispatch(setIssuesProcessingDone());
    }
};

// Issues processing (sending)
export const setIssuesProcessing = () => {
    return {
        type: ISSUES_PROCESSING
    }
}

// Processing done
export const setIssuesProcessingDone = () => {
    return {
        type: ISSUES_PROCESSING_DONE
    }
}